import { render } from "./SalesDeliveryOperDetailsPage.vue?vue&type=template&id=0eb562c9&ts=true"
import script from "./SalesDeliveryOperDetailsPage.vue?vue&type=script&lang=ts"
export * from "./SalesDeliveryOperDetailsPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__